function EmailConfirmationOptionsProvider() {
    'ngInject';

    const options = {
        isEmailConfirmationFlagChecked: true
    };

    this.setOption = function (option, value) {
        if (options.hasOwnProperty(option)) {
            options[option] = value;
        }
    };

    this.getOption = function (option) {
        if (options.hasOwnProperty(option)) {
            return options[option];
        }
    };

    this.$get = () => options;
}

export default EmailConfirmationOptionsProvider;

angular
    .module('BBPublicBooking')
    .provider('EmailConfirmationOptions', EmailConfirmationOptionsProvider);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/public-booking/email-confirmation-checkbox/bb_email_confirmation_options.provider.js